import React from 'react';
import { motion } from 'framer-motion';
interface HeroSectionProps {
  title: string;
  subtitle?: string;
  ctaText?: string;
  ctaLink?: string;
  backgroundImage?: string;
  theme?: 'navy' | 'rosegold' | 'sand' | 'blush';
  height?: 'full' | 'large' | 'medium';
  tagline?: string;
}
export function HeroSection({
  title,
  subtitle,
  ctaText,
  ctaLink = '#',
  backgroundImage,
  theme = 'blush',
  height = 'large',
  tagline
}: HeroSectionProps) {
  const themeClasses = {
    navy: 'bg-navy text-white',
    rosegold: 'bg-rosegold text-white',
    sand: 'bg-sand text-navy',
    blush: 'bg-blush-light text-navy'
  };
  const heightClasses = {
    full: 'min-h-screen',
    large: 'min-h-[80vh] pt-24',
    medium: 'min-h-[60vh] pt-24'
  };
  return <div className={`relative flex items-center justify-center overflow-hidden ${heightClasses[height]} ${themeClasses[theme]}`} data-id="element-85">
      {backgroundImage && <>
          <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
        backgroundImage: `url(${backgroundImage})`
      }} data-id="element-86" />
          <div className={`absolute inset-0 z-10 ${theme === 'blush' ? 'bg-gradient-to-b from-blush-light/70 to-cream/90' : theme === 'sand' ? 'bg-sand/80' : 'bg-navy/60'}`} data-id="element-87" />
        </>}

      <div className="relative z-20 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-88">
        {tagline && <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="mb-6" data-id="element-89">
            <span className="text-sm md:text-base font-bold tracking-widest text-rosegold uppercase bg-white/50 backdrop-blur-sm px-4 py-2 rounded-full inline-block shadow-sm" data-id="element-90">
              {tagline}
            </span>
          </motion.div>}

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut',
        delay: tagline ? 0.1 : 0
      }} className="text-4xl md:text-5xl lg:text-7xl font-serif font-medium leading-tight mb-6" data-id="element-91">
          {title}
        </motion.h1>

        {subtitle && <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut',
        delay: 0.2
      }} className={`${`${`text-lg md:text-xl max-w-3xl mx-auto mb-10 font-light leading-relaxed ${theme === 'blush' || theme === 'sand' ? 'text-navy/80' : 'text-sand-light/90'}`} font-[600] font-[Montserrat,_sans-serif]`} font-[500]`} data-id="element-92">
            {"Que ce soit par la cr\xE9ation de votre empire cosm\xE9tique ou par l'investissement, on vous donne les cl\xE9s de votre ind\xE9pendance."}
          </motion.p>}

        {ctaText && <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut',
        delay: 0.4
      }} data-id="element-93">
            <a href={ctaLink} target="_blank" rel="noopener noreferrer" className={`inline-block px-8 py-4 rounded-full text-sm font-medium tracking-wide transition-all shadow-lg hover:-translate-y-1 ${theme === 'blush' || theme === 'sand' ? 'bg-rosegold text-white shadow-rosegold/30 hover:bg-rosegold-dark' : 'bg-white text-navy shadow-white/20 hover:bg-rosegold hover:text-white'}`} data-id="element-94">
              {ctaText}
            </a>
          </motion.div>}
      </div>
    </div>;
}